export default "__VITE_PUBLIC_ASSET__95031097__"